var render = function render(){var _vm=this,_c=_vm._self._c;return _c('msisdn-form',{attrs:{"msisdn":_vm.msisdn}})
}
var staticRenderFns = []

export { render, staticRenderFns }